<template>
  <div class="people-warp">
    <div class="head-title">
      <div class="pic" style="background-image:url('static/images/ex_pic16.jpg');"></div>
      <div class="content-wrap">
        <span class="name">{{personnelDetail.name}}</span>  
      </div>
      <div class="content-wrap">
        <span class="code-number">执业证号：{{personnelDetail.codeNumber}}</span>
      </div>
      <div class="content-wrap">
        <span class="company">执业机构：{{personnelDetail.company}}</span>
        <span class="git-in-icon">
          <i class="iconfont icon-photograph"></i>
          实时监控
        </span>
      </div>
    </div>
    <div class="cont-warp">
      <div class="message-warp">
        <div class="go-out-message">
          <div class="title">外出办证信息</div>
          <p>公证事项:{{personnelDetail.goOut.matter}}</p>
          <p>申请人:{{personnelDetail.goOut.applicant}}</p>
          <p>核准地址:{{personnelDetail.goOut.address}}</p>
        </div>
        <div class="go-out-map">
          <div class="title">公证员现在位置</div>
          <innerMap></innerMap>
        </div>
      </div>
      <div class="server-warp">
        <div class="title-go-out">外出动态</div>
          <out-list :outList="personnelDetail.dynamic"></out-list>
      </div>
    </div>
    <a href="javascript:;" class="go-back" @click="goback(true)">&times;</a>
  </div>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex'
  import innerMap from '@/components/inner-map'
  import outList from '@/components/go-out-list'
  export default {
    components: { outList, innerMap },
    props: [
    ],
    data () {
      return {
        fullScreenSwite: false
      }
    },
    computed: {
      ...mapGetters([
        'personnelDetail'
      ])
    },
    watch: {
    },
    methods: {
      ...mapActions([
        'AgetBack'
      ]),
      hoverCityOver () {
      },
      hoverCityOut (iner) {
      },
      back (swit) {
        this.AgetBack(swit)
      },
      goback (swit) {
        this.AgetBack(swit)
        window.history.back()
      },
      fullScreen () {
        if (this.fullScreenSwite === false) {
          this.fullScreenSwite = true
        } else {
          this.fullScreenSwite = false
        }
      }
    },
    created () {
      setTimeout(() => {
      }, 1000)
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss">
  @import '../assets/scss/variables';
  @import '../assets/scss/mixins';
  .people-warp {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    width: 900px;
    height: 700px;
    text-align: center;
    border-radius: 6px;
    border: 2px solid rgba(#5389d8, .9);
    background: rgba($brand, .9);
    .head-title {
      position: relative;
      width: 100%;
      height: 160px;
      padding-left: 200px;
      padding-top: 15px;
      padding-bottom: 15px;
      padding-right: 35px;
      .pic {
        position: absolute;
        top: 15px;
        left: 35px;
        width: 150px;
        height: 130px;
        border: 1px solid $white;
        background-size: cover;
      }
      .content-wrap {
        widows: 100%;
        height: calc(100%/3);
        text-align: left;
        font-size: 20px;
        line-height: 43px;
      }
      span.name {
        font-size: 25px;
      }
      span {
        color: $white;
      }
    }
    .git-in-icon {
      position: relative;
      max-width: 30%;
      height: 30px;
      margin-top: 10px;
      padding-right: 25px;
      padding-left: 5px;
      line-height: 30px;
      border-radius: 4px;
      border: 1px solid $brand-green;
      background: rgba($brand-green, .3);
      text-align: center;
      color: $white;
      display: inline-block;
      float: right;
      display: block;
      .iconfont {
        color: $white;
      }
    }
    .cont-warp {
      width: 100%;
      height: calc(100% - 160px);
      padding: 0 35px 75px 35px;
      @include clearfix;
    }
    .message-warp {
      width: calc(40% - 10px);
      height: 100%;
      padding: 15px;
      border-radius: 6px;
      border: 1px solid $brand-blue;
      float: left;
      color: $white;
    }
    .server-warp {
      width: calc(60% - 10px);
      height: 100%;
      padding: 15px;
      border-radius: 6px;
      border: 1px solid $brand-blue;
      float: right;
      color: $white;
    }
    .go-out-message {
      width: 100%;
      height: 150px;
      background: rgba(black, .3);
      .title {
        width: 100%;
        height: 40px;
        margin-bottom: 10px;
        padding-right: 10px;
        padding-left: 10px;
        line-height: 40px;
        text-align: left;
        font-size: 18px;
        color: $white;
        background: $brand-green;
      }
      p {
        margin: 0 0 10px 0;
        padding-right: 10px;
        padding-left: 10px;
        text-align: left;
        font-size: 16px;
      }
    }
    .go-out-map {
      width: 100%;
      height: calc(100% - 160px);
      margin-top: 10px;
      background: rgba(black, .3);
      .title {
        width: 100%;
        height: 40px;
        padding-right: 10px;
        padding-left: 10px;
        line-height: 40px;
        text-align: left;
        font-size: 18px;
        color: $white;
        background: $brand-green;
      }
    }
    .title-go-out {
      width: 100%;
      height: 40px;
      padding-right: 10px;
      padding-left: 10px;
      line-height: 40px;
      text-align: left;
      font-size: 18px;
      color: $white;
      background: $brand-green;
    }
  }
</style>




// WEBPACK FOOTER //
// people.vue?574b83a2